/**
 * OQ-287 · Khối "Lịch sao lưu tự động".
 *
 * ── Ba khoá được ĐỌC nhưng chưa bao giờ ĐẶT được (OQ-286) ──────────────────
 *
 * `backup.auto_enabled`, `backup.interval_hours`, `backup.keep_count` có từ M7
 * và `backup.schedule.ts` đọc chúng thật. Nhưng không màn hình nào cho đổi —
 * muốn tắt sao lưu tự động thì phải sửa thẳng trong CSDL.
 *
 * ── Vì sao bản đầu SAI, theo hai cách đều đã được cảnh báo ─────────────────
 *
 * Bản đầu tự quản state riêng, tự có nút **Lưu**, và tự dựng công tắc bằng
 * `<label className="switch"><input/><span/></label>`.
 *
 *  1. **Nút Lưu thừa** — trang đã có "Lưu thay đổi" ở đầu, áp cho cả form.
 *     Đúng lỗi OQ-270; chủ dự án đã nói y hệt câu ấy một lần rồi.
 *
 *  2. **Công tắc vô hình** — CSS đòi `.switch .track`, tôi viết `<span />`
 *     không class. `css-class-exists` vẫn xanh vì `.switch` CÓ trong CSS. Đúng
 *     cái bẫy đã ghi: chốt canh *tên lớp tồn tại*, không canh *lớp áp được vào
 *     chỗ đang dùng*.
 *
 * Nay dùng `SettingSwitch` / `SettingNumber` như mọi tab khác: chúng ghi vào
 * `draft` chung, và nút "Lưu thay đổi" ở đầu trang gửi tất cả một lượt.
 *
 * > Bài học chung của cả hai lỗi: **tôi dựng cái mới thay vì tìm cái đã có.**
 * > Một trang cài đặt sáu tab chắc chắn đã có mẫu cho "công tắc" và cho "lưu" —
 * > không đi tìm là tự chuốc hai lỗi mà người dùng nhìn thấy ngay từ ảnh chụp
 * > đầu tiên.
 */

import { SettingNumber, SettingSwitch } from './SettingsControls';
import { Icon } from '../../components/Icon';
import { useI18n } from '../../lib/i18n';

export function BackupSchedulePanel({
  bat,
  gio,
  giu,
  onDoi,
}: {
  bat: boolean;
  gio: number;
  giu: number;
  /** Ghi vào `draft` của trang — nút "Lưu thay đổi" ở đầu gửi tất cả. */
  onDoi: (key: string, value: unknown) => void;
}): JSX.Element {
  const { t } = useI18n();

  return (
    <div className="card" data-od-id="backup-schedule-card">
      <div className="card-head">
        <div className="grow">
          <h2>{t('settings.backupSchedule.title')}</h2>
          <div className="sub">{t('settings.backupSchedule.sub')}</div>
        </div>
      </div>

      <div className="card-body">
        <SettingSwitch
          label={t('settings.backupSchedule.enabled')}
          sub={t('settings.backupSchedule.enabledSub')}
          checked={bat}
          onChange={(next) => onDoi('backup.auto_enabled', next)}
        />

        {/*
          Ẩn hai ô khi đã tắt: một chu kỳ và một số bản giữ lại chỉ có nghĩa khi
          có việc chạy. Để nguyên sẽ mời người dùng chỉnh một thứ không ảnh
          hưởng gì, rồi tự hỏi vì sao không thấy tác dụng.
        */}
        {bat ? (
          <>
            <SettingNumber
              label={t('settings.backupSchedule.interval')}
              sub={t('settings.backupSchedule.intervalHint')}
              value={gio}
              min={1}
              max={168}
              onChange={(next) => onDoi('backup.interval_hours', next)}
            />
            <SettingNumber
              label={t('settings.backupSchedule.keep')}
              sub={t('settings.backupSchedule.keepHint')}
              value={giu}
              min={1}
              max={365}
              onChange={(next) => onDoi('backup.keep_count', next)}
            />
          </>
        ) : null}

        <div className="scope-note">
          <Icon name="info" size={17} />
          <span>{t('settings.backupSchedule.note')}</span>
        </div>
      </div>
    </div>
  );
}
